import React from 'react';
import Icon from 'components/library/Icon';
import IconButton from 'components/library/IconButton';
import withTranslations from 'helpers/withTranslations';

const i18nPath = 'components.app.todos.ActionButton.components.RemoveActionButton';

function handleEvent(event, onAction, onStatusMenu, value, intent) {
  event.stopPropagation();

  if (onStatusMenu && event.altKey) {
    onStatusMenu(event);
  } else {
    onAction(value, intent);
  }
}

const RemoveActionButton = ({
  className,
  value,
  intent,
  onRemove,
  onStatusMenu,
  t,
}) => {
  if (!onRemove) {
    throw new Error(`'onRemove' is a required prop`);
  }

  return (
    <IconButton
      className={className}
      onClick={e => handleEvent(e, onRemove, onStatusMenu, value, intent)}
      tooltip={t(i18nPath, 'label')}
      data-action="uncommit"
    >
      <Icon type={t(i18nPath, 'icon')} />
    </IconButton>
  );
}

export default withTranslations(RemoveActionButton);
